'use client';

import { type MouseEvent } from 'react';

import { type NavBar } from '@/api/types/navigationTypes';
import { SearchIcon } from '@/components/SearchIcon/SearchIcon';

import { AccountNavPopover } from './AccountNavPopover';
import { PackageSelectNavItems } from './PackageSelectNavItems';

export interface AccountNavigationLink {
  title: string;
  href?: string;
  isSearchActive?: boolean;
  onClick?: () => void;
}

interface HeaderAccountNavProps {
  accountNavigationLinks?: AccountNavigationLink[];
  color?: 'white' | 'secondary';
  isSearchActive?: boolean;
  subNavBar?: NavBar;
}

export function HeaderAccountNav(props: HeaderAccountNavProps): React.ReactNode | null {
  const { accountNavigationLinks, color: bgColor, isSearchActive, subNavBar } = props;

  const subscriptionSection = subNavBar?.subitems?.find((item) => item.item_key === 'subscriptions');
  const subscriptionItems = subscriptionSection?.subitems ?? [];
  const activeSubscriptionItems = subscriptionItems.filter((item) => item.visibility !== 'locked');
  const inactiveSubscriptionItems = subscriptionItems.filter((item) => item.visibility === 'locked');

  const isUpsellIconVisible = subscriptionItems.length > 0;

  if (!accountNavigationLinks || accountNavigationLinks.length <= 0) {
    return null;
  }

  const handleNavigationClick = (event: MouseEvent, navItem: AccountNavigationLink): void => {
    if (!navItem.href) {
      event.preventDefault();
    }

    navItem.onClick?.();
  };

  const contrastTextColor = bgColor === 'white' ? '#041129' : 'white';

  return (
    <>
      {/* Mobile */}
      <div className="order-4 ml-auto flex items-center gap-x-5 sm:hidden">
        <SearchIcon isSearchActive={isSearchActive} />
        <AccountNavPopover
          accountNavigationLinks={accountNavigationLinks}
          onNavigationClick={handleNavigationClick}
          contrastTextColor={contrastTextColor}
          variant="mobile"
        />
      </div>

      {/* Desktop */}
      <div className="order-4 ml-auto hidden items-center gap-x-[8px] sm:flex sm:gap-x-[30px]">
        {isUpsellIconVisible ? (
          <PackageSelectNavItems
            activeSubscriptionItems={activeSubscriptionItems}
            inactiveSubscriptionItems={inactiveSubscriptionItems}
          />
        ) : null}
        <SearchIcon isSearchActive={isSearchActive} />
        <AccountNavPopover
          accountNavigationLinks={accountNavigationLinks}
          onNavigationClick={handleNavigationClick}
          contrastTextColor={contrastTextColor}
          variant="desktop"
        />
      </div>
    </>
  );
}
